import React from 'react'
import FaqHead from '../../HomePage/Faq/FaqHead'
import MeaFaqMain from './MeaFaqMain'

const MeaFaq = () => {
  return (
    <div className="faqContainer">
      <div className="faqContent">
        <FaqHead heading="MEA Apostille Service in Bangalore" />
        <MeaFaqMain />
      </div>
    </div>
  )
}

export default MeaFaq
